const getQueryParamFromString = (
  scriptSrc: string,
  paramName: string,
): string | null => {
  const url = new URL(scriptSrc);
  return url.searchParams.get(paramName);
};

export { getQueryParamFromString };
